export const SafeLocalStorage = {
    setItem(key, value) {
        if (isSafe()) {
            localStorage.setItem(key, JSON.stringify(value));
        }
    },
    getItem(key) {
        if (isSafe()) {
            const value = localStorage.getItem(key);
            if (value) {
                try {
                    return JSON.parse(value);
                }
                catch {
                    return null;
                }
            }
        }
        return null;
    },
    removeItem(key) {
        if (isSafe()) {
            localStorage.removeItem(key);
        }
    }
};
function isSafe() {
    return typeof window !== 'undefined' && typeof localStorage !== 'undefined';
}
